import { Injectable } from '@angular/core';
import {
	CONNECTION_TYPE,
	IConnectionOperation,
	IDocumentsOperation,
	OPERATION_STATUS,
	OPERATION_TYPE,
} from '../../models/user-identification';

@Injectable({
	providedIn: 'root',
})
export class ConnectionsHelperService {
	constructor() {}

	public getConnectionDocType(connectionType: CONNECTION_TYPE, operation: IConnectionOperation): IDocumentsOperation {
		const totalTries = operation.config?.total_tries ?? 2;
		return {
			type: OPERATION_TYPE.DOCUMENTS,
			uuid: operation.uuid,
			config: {
				tutorial: false,
				title: null,
				allow_photo: false,
				docs: [
					{
						uuid: operation.uuid,
						document_type_uuid: null,
						type: connectionType,
						allow_photo: false,
						required: true,
						total_tries: totalTries,
						method: 'manual',
						min: 1,
						max: 1,
						title: null,
						description: null,
						instructions: null,
						instructions_photo: null,
						preview_validation: null,
						match_data: null,
						ruleset: null,
						post_poned_expiration: null,
						evaluation: operation.config?.evaluation,
						connection_type: connectionType,
					},
				],
			},
			completed: false,
			state: OPERATION_STATUS.INIT,
		};
	}

	public initNumberOfTries(operation: IConnectionOperation): void {
		if (
			operation?.config &&
			(operation?.config?.numberOfTries == undefined || operation?.config?.numberOfTries == null)
		) {
			operation.config.numberOfTries = 0;
		}
	}
}
